export default __webpack_public_path__ + "static/14-34395a23530b4a9220d22d3cee41301e.png";